import { render, staticRenderFns } from "./permasalahan_pembangunan.vue?vue&type=template&id=92d38140&"
import script from "./permasalahan_pembangunan.vue?vue&type=script&lang=js&"
export * from "./permasalahan_pembangunan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports